<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-col cols="12">
      <v-combobox
        dense
        required
        v-model="commn_grp"
        :items="commn_grp_list"
        item-text="grp_name"
        label="Group"
        hint="Select Group"
         persistent-hint
        outlined
        @change="getCommnMsg"
      />
    </v-col>
    <template v-if="commn_grp!=null">
      
      <v-row  dense>
      <v-col cols="12" sm="8">
        <v-text-field label="Title" dense v-model.trim="title" placeholder="Colleges reopens"></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
       <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date" label="From Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false" :min="new Date().toISOString().substr(0, 10)" @change="calculateDays()"></v-date-picker>
            </v-menu>
      </v-col>
      </v-row>
      <v-col cols="12">
        <v-textarea
          label="Description"
          v-model.trim="description"
          dense
          value
          placeholder="Colleges reopens on...."
          hint="Enter description of notice or home work"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="attachments"
          placeholder="Upload attachment if any"
          label="Attachment"
          multiple
          dense
          prepend-icon="mdi-paperclip"
        >
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">{{ text }}</v-chip>
          </template>
        </v-file-input>
      </v-col>
      <v-btn @click="putGroupNotice" color="info" :loading="send_btn_load">Send</v-btn>
    </template>
    <template v-if="grp_msg !=null">
      <v-data-table :items="grp_msg" :headers="headers" class="elevation-1" :search="search">
        <template v-slot:[`item.edit`]="{item}">
          <div>
            <v-btn color="primary" icon dark @click="editDialog(item)" title="Edit Group Notice">
              <v-icon>mdi-file-document-edit</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.status`]="{item}">
         <v-btn color="info" icon dark @click="getStatus(item)">
            <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>
         <template v-slot:[`item.delete`]="{item}">
          <v-btn color="info" icon dark @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="edit_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  disabled
                  v-model="editedItem.date"
                  label="Sent Date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  disabled
                  v-model="editedItem.grp_name"
                  label="Group Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  disabled
                  v-model="editedItem.grp_code"
                  label="Group Code"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem.title" label="Title"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Description"
                  v-model="editedItem.description"
                  dense
                  placeholder="Colleges reopens on...."
                  hint="editable"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-file-input
                v-model="edit_attachments"
                placeholder="Upload attachment if any"
                label="Attachment"
                prepend-icon="mdi-paperclip"
                multiple
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
            <!-- <template v-if="attachments.length>0">
              <h3>Attachments</h3>
              <ol>
                <li v-for="attach in attachments" :key="attach.attach_id">
                  <a :href="awspath+attach.link">{{attach.attach_name}}</a>
                  <v-btn
                    text
                    title="Delete attachment"
                    :loading="delete_acttach_load"
                    @click="deleteAttachment(attach)"
                  >
                    <v-icon color="red">mdi-window-close</v-icon>
                  </v-btn>
                </li>
              </ol>
            </template> -->
            <template v-if="editedItem.attachment_list.length>0">
              <h3>Attachments</h3>
              <ol>
                <li v-for="attach in editedItem.attachment_list" :key="attach.attach_id">
                  <a :href="awspath+attach.link" target="_blank">{{attach.attach_name}}</a>
                  <v-btn
                    text
                    title="Delete attachment"
                    :loading="delete_acttach_load"
                    @click="deleteAttachment(attach)"
                  >
                    <v-icon color="red">mdi-window-close</v-icon>
                  </v-btn>
                </li>
              </ol>
            </template>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="edit_save_attachment_load" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_status"
      style="margin-top: 10%"
      fullscreen
      hide-overlay
      transition="dialog-top-transition"
    >
      <v-card class="mx-auto">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Notice Status</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog_status = false">
              <v-icon>mdi-close</v-icon>Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <br />
        <v-card-text>show list</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    edit_attachments:[],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    modal: false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    commn_grp_list: null,
    attachments: [],
    dialog_status: false,
    commn_grp_list: null,
    commn_grp: null,
    grp_msg: null,
    title: null,
    edit_dialog: false,
    edit_save_attachment_load: false,
    attachments: [],
    description: null,
    send_btn_load: false,
    search: "",
    headers: [
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
      { text: "Date", value: "date", sortable: true },
      { text: "Group Name", value: "grp_name", sortable: true },
      { text: "Group Code", value: "grp_code", sortable: true },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Delete", value: "delete", sortable: false }
    ],
    editedItem: {
      grp_msg_id: null,
      title: null,
      description: [],
      date: null,
      grp_name: null,
      grp_code: null,
      attachment_list:[]
    },
    editItemIndex: -1
    //
  }),
  watch: {
    edit_dialog(val) {
      val || this.close();
    }
  },
  methods: {
     deleteAttachment(attach) {
      const formData = {
        attach_id: attach.attach_id,
        grp_msg_id:this.editedItem.grp_msg_id 
      };
      this.delete_acttach_load = true;
      axios
        .post("/communicationGroup/deleteGroupAttachment", formData)
        .then(res => {
          if (res.data.status == "YES") {
            const index = this.editedItem.attachment_list.indexOf(attach);
            this.editedItem.attachment_list.splice(index, 1);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_acttach_load = false;
        });
    },
     onload(){
    console.log("calendar");
    axios
      .post("/communicationGroup/communicationGroup")
      .then(res => {
        this.commn_grp_list = res.data.commn_grp_list;
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {});
    },
    deleteItem(item){
      const formData = {
        grp_msg_id: item.grp_msg_id,
      };
      axios
        .post("/communicationGroup/deletecommMessage", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            this.showSnackbar("#4CAF50", "Message Deleted Successfully..");
            this.getCommnMsg();
            return
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },

     getStatus(item){
      //this.$store.commit('setcommn_id', item);
      localStorage.setItem("commn_id",item.grp_msg_id)
      let routeData = this.$router.resolve({name:'message-status'});
      window.open(routeData.href, '_blank');
     // this.$router.push({name:'communication-status'})
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getMsgStatus(item) {
      this.dialog_status = true;
    },
    putGroupNotice() {
      if (
        this.title == null ||
        this.title == "" ||
        this.description == null ||
        this.description == ""
      ) {
        this.showSnackbar(
          "#b71c1c",
          "Please enter title and description of calendar!!!"
        );
        return;
      }

      let formData = new FormData();
      for (var i = 0; i < this.attachments.length; i++) {
        let file = this.attachments[i];

        formData.append("files", file);
      }
      formData.append("group_id", this.commn_grp.grp_id);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("type", "Calendar");
      formData.append("event", "");
      formData.append("eventdate",this.date);
      this.send_btn_load = true;
      axios
        .post("/communicationGroup/putGroupMesssge", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            this.showSnackbar("#4CAF50", "Calendar Event added successfully");
            this.title = null;
            this.description = null;
            this.attachments = [];
            this.commn_grp = null;
            this.grp_msg = null;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          this.send_btn_load = false;
        });
    },
    getCommnMsg() {
      const formData = {
        group_id: this.commn_grp.grp_id,
        comm_type:"Calendar"
      };
      axios
        .post("/communicationGroup/getCommnMsg", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            this.grp_msg = res.data.grp_msg;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    close() {
      this.edit_dialog = false;
    },
    editDialog(item) {
      this.awspath = localStorage.getItem("awspath");
      this.editedItem = item;
      this.edit_dialog = true;
      this.editItemIndex = this.commn_grp_list.indexOf(item);
      //alert(this.editItemIndex)
    },
    save() {
      this.edit_save_attachment_load = true;
      let formData = new FormData();
       for (var i = 0; i < this.edit_attachments.length; i++) {
        let file = this.edit_attachments[i]; 
        formData.append("files", file);
      }
      formData.append("title", this.editedItem.title);
      formData.append("description", this.editedItem.description);
      formData.append("grp_msg_id", this.editedItem.grp_msg_id);
      axios
        .post("/communicationGroup/editGroupNotice", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            //Object.assign(this.notice_list[this.editItemIndex], this.editedItem)
            this.showSnackbar("#4caf50", "Notice updated...");
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.edit_save_attachment_load = false;
          // this.attachments = [];
          this.close();
          this.getCommnMsg()
        });
    }
  },
  mounted() {
    this.onload();
  }
};
</script>